import { useSelector } from 'react-redux';

import { DefaultAvatar } from 'atoms/default-avatar';
import { capitalizeFirstLetter, isEmpty } from 'util';

export default function GroomerInfo() {
  const { locationUser } = useSelector((state) => state.appointment);
  const { groomers } = useSelector((state) => state.groomers);

  if (!locationUser || isEmpty(locationUser)) return null;

  const groomerFullInfo = groomers?.filter(
    (groomer) => groomer.user.uuid === locationUser.uuid
  );

  const groomerAvatar = locationUser?.links?.image?.desktop?.small;
  const groomerName = locationUser?.firstName ?? 'Groomer';
  const groomerAnimalTypes = capitalizeFirstLetter(
    groomerFullInfo?.[0]?.animal?.type
      ?.map((type) => `${type.value}s`)
      .join(', ')
      .toLowerCase()
  );

  return (
    <div className="flex-row mb-12 p-24 border-light-purple radius-24">
      <DefaultAvatar avatar={groomerAvatar} size="small" />
      <div className="flex-column ml-8">
        <p className="f13 bold">{groomerName}</p>
        <p className="f11 c-primary-purple">{groomerAnimalTypes}</p>
      </div>
    </div>
  );
}
